<template>
    <div>
        <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    description=""
                    label="Senha atual"
                    label-for="currentpassword"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-input v-model="currentPassword" id="currentpassword" type="password"></b-form-input>
                    </b-form-group>          
                </b-form>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    :description="passwordMessage"
                    label="Nova senha"
                    label-for="password"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-input v-model="password" id="password" :class="passwordClass" type="password" @blur="checkPassword()"></b-form-input>
                    </b-form-group>          
                </b-form>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12">
                <b-form>
                    <b-form-group
                    :description="password2Message"
                    label="Confirmar senha"
                    label-for="password2"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-input v-model="password2" id="password2" :class="password2Class" type="password" @blur="checkPassword()"></b-form-input>
                    </b-form-group>          
                </b-form>
            </b-col>
        </b-row>

        <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.changePasswordErrorMessage && this.changePasswordErrorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.changePasswordErrorMessage }}</div>
        </b-input-group>

        <div slot="footer" class="text-right">
            <b-button variant="primary" @click="changePassword"><i class="fa fa-check"></i> Alterar Senha</b-button>
        </div>

    </div>
</template>

<script>

import axios from "axios";

export default {
  name: "PasswordComponent",
  data() {
    return {
        passwordPolicy: '',
        
        currentPassword: '',
        password: '',
        passwordClass: '',
        passwordMessage: '',

        password2: '',
        password2Class: '',
        password2Message: '',

        changePasswordErrorMessage: ''
    }
  },
  methods: {
    async getPreferences() {
        var s = this
        await axios.get(
          this.$store.state.ws_url + "/sys/preference/password/policy?companyId=" + this.$store.state.config.companyId
        ).then(function(resp) {
          s.passwordPolicy = new RegExp(resp.data.obj.stringPreference)
          s.passwordPolicyMessage = resp.data.obj.description
        }).catch(function(error) {
          s.passwordPolicy = /^.{8,}$/
        })
      },
      
      checkPassword() {
        var s = this
        if(this.password && this.password.length > 0) {
          if(this.passwordPolicy.test(this.password)) {
            s.passwordClass = ''
            s.passwordMessage = ''

            if(this.password2 && this.password2.length > 0) {
              s.password2Class = this.password === this.password2 ? '' : 'is-invalid'
              s.password2Message = this.password === this.password2 ? '' : 'Senhas diferentes. Verifique e tente novamente.'
            }
            else {
                s.password2Class = ''
                s.password2Message = ''
            }
          }
          else {
            s.passwordClass = 'is-invalid'
            s.passwordMessage = this.passwordPolicyMessage
            s.password2Class = ''
            s.password2Message = ''
          }
        }
        else {
          s.passwordClass = ''
          s.passwordMessage = ''
          s.password2Class = ''
          s.password2Message = ''
        }
      },

      changePassword() {
        this.changePasswordErrorMessage = '';

        if(this.currentPassword != '' && this.password != '' && this.password2 != '' ) {
          if(this.password == this.password2) {
            if(this.password != this.currentPassword) {
              this.saveChangePassword( this.$store.state.currentUser );
            }
            else {
              this.changePasswordErrorMessage = 'Nova senha deve ser diferente da senha antiga.';
            }
          }
          else {
            this.changePasswordErrorMessage = 'Nova senha e confirmar senha diferentes. Verifique e tente novamente.';
          }
          
        }
        else {
          this.changePasswordErrorMessage = 'Por favor preencha os campos obrigatórios.';
        }
      },

      async saveChangePassword(currentUser) {
        this.errormessage = '';
        var s = this;

        await axios.post(
            this.$store.state.ws_url + "/user/changepassword",
            {
              "uid": currentUser.id,
              "sid": currentUser.sid,
              "userPassword": s.currentPassword,
              "newPassword": s.password
            }
        ).then(function(resp) {
          s.currentPassword = '';
          s.password = '';
          s.password2 = '';
          s.passwordModal = false;

          toast ({
            type: VueNotifications.types.success,
            title: 'Senha',
            message: 'Senha alterada com sucesso.',
            timeout: 2000
          });
        }).catch(function (error) {
          s.changePasswordErrorMessage = error.response.data.message;
        });
        
      }
  },
  mounted: function() {
    this.getPreferences()
  }
};

</script>
